import { Reveal } from "@components/ui";
import documentIcon from "@assets/images/Frame-1618869485.svg";

const resources = [
  {
    title: "Gas Safety Guide",
    format: "PDF",
    category: "Residential",
  },
  {
    title: "Emergency Procedure Sheet",
    format: "PDF",
    category: "General",
  },
  {
    title: "Commercial Kitchen Safety Checklist",
    format: "PDF",
    category: "Commercial",
  },
  {
    title: "Annual Inspection Sample Report",
    format: "PDF",
    category: "Inspection",
  },
  {
    title: "Pressure Testing Certificate Sample",
    format: "PDF",
    category: "Certificate",
  },
];

export function DownloadableResourcesSection() {
  return (
    <section className="w-full bg-[#f5f5f7] overflow-hidden px-5 md:px-10 lg:px-[180px] pt-0 pb-12 md:pb-16 lg:pb-[100px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col items-center gap-10 md:gap-14 lg:gap-16">
        {/* Title */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-4 max-w-[1112px] mx-auto text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase">
              Resources
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1]">
              Downloadable Safety Resources
            </h2>
            <p className="text-[14px] md:text-base lg:text-[22px] tracking-[-0.04em] text-[#62636c] max-w-[800px]">
              Access our comprehensive safety documentation and guidelines.
            </p>
          </div>
        </Reveal>

        {/* Download Cards */}
        <Reveal direction="up" className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5 md:gap-4">
            {resources.map((resource, index) => (
              <div
                key={index}
                className={`group flex items-center gap-4 md:gap-5 p-4 md:p-5 rounded-[16px] bg-white hover:shadow-[0_4px_20px_rgba(0,0,0,0.07)] transition-all duration-300 border border-transparent hover:border-[#e8e9ed] cursor-pointer ${
                  index === resources.length - 1 ? "md:col-span-1" : ""
                }`}
              >
                {/* Document Icon */}
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-[14px] bg-[#f24d2b]/8 flex items-center justify-center shrink-0 group-hover:bg-[#f24d2b]/15 transition-colors">
                  <img
                    src={documentIcon}
                    alt=""
                    className="w-7 h-7 md:w-8 md:h-8"
                  />
                </div>

                {/* Text */}
                <div className="flex-1 flex flex-col gap-0.5 min-w-0">
                  <p className="text-[15px] md:text-[18px] lg:text-[20px] tracking-[-0.03em] text-[#1e1f24] font-medium truncate">
                    {resource.title}
                  </p>
                  <div className="flex items-center gap-2">
                    <span className="text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.05em] text-[#62636c]/50">
                      {resource.category}
                    </span>
                    <span className="text-[10px] text-[#62636c]/30">|</span>
                    <span className="text-[11px] md:text-[12px] font-medium text-[#f24d2b]/70">
                      {resource.format}
                    </span>
                  </div>
                </div>

                {/* Download Button */}
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-[#f8f9fb] group-hover:bg-[#122d63] flex items-center justify-center shrink-0 transition-colors duration-300">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
                    <path
                      d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"
                      className="stroke-[#62636c] group-hover:stroke-white transition-colors"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
